// extracted by mini-css-extract-plugin
export default {"group":"MenuGroup_group__ACcqe"};